<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'App',
  
  mounted(){
    this.check_auth()
  },
  methods:{
    ...mapActions("auth",["check_auth"])
  }
}
</script>

<style lang="less">
@import 'https://fonts.googleapis.com/css?family=Montserrat:300,400,500&display=swap';
@import 'assets/reset.css';
@import 'assets/variable.less';
@import 'assets/main.css';
#app{
  height: 100%;
  .link{
    font-size: 14px;
    color: #2F2B2B;    
  }
  form{
    display: flex;
    flex-direction: column;
    input{
      margin-bottom: 20px;
      padding: 20px;
      background: #F6F6F6;
      border: none;
      width: calc(100% - 40px);
    }
    select{
      margin-bottom: 20px;
      padding: 20px;
      background: #F6F6F6;
      border: none;
      width: 100%;
    }

  }
  .resume{
    form{
      input, select{
        background-color: white;
        margin:10px 0;
      }
    }
  }
  button{
    border: none;
    max-width: 200px;
  }
  .grid{
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap:20px;
  }
  
  a,button{
      text-decoration: none;
      &.btn{
          background-color: @backgroundColor;
          color:#ffffff;
          padding: 1.5rem 2rem;
          display: inline-block;
          box-sizing: border-box;
          margin:10px 0;
          text-transform: uppercase;
          font-size:.8rem;
          transition: all .3s;
          &:hover{
              background-color:@mainColor;
              color:#000000;
          }
          &.primary{
              background-color:@mainColor;
              color:#000000;
              &:hover{
                  background-color: @backgroundColor;
                  color:#ffffff;
              }
          }
          @media only screen and (max-width: 980px){
              background-color: #ffffff;
              color:#000000;
          }

      }
  }
  
  .alert {
    background-color: #000000;
    color:white;
    padding: 30px;
    margin: 40px;
    text-align: center;
  }
}
</style>